import { cronosClient } from "@/config/client"

export type ObjectiveStatus = "pending" | "rescheduled"
export type ActivityStatus = "pending" | "rescheduled" | "approved" | "skipped" | "failed"
export type ActivityType = "flashcards" | "diagnostics" | "lessons" | "challenges" | "basic"

export interface Subject {
  id: string
  name: string
}

export interface Unit {
  id: string
  name: string
}

export interface Activity {
  id: string
  activityId: string
  estimatedDuration: string
  dateTime: string
  status: ActivityStatus
  score: number
  subject: Subject
  type: ActivityType
  name: string
  unit: Unit
  userWeeklyObjectiveId: string
  basic?: {
    subType: "lecture" | "video" | "homework"
    externalUrl: string
  }
}

interface GetActivitiesRequestParams {
  startDate?: string
  endDate?: string
  userWeeklyObjectiveId?: string
}

export interface GetActivitiesResponse {
  description: Activity[]
}

export function get(params: GetActivitiesRequestParams) {
  return cronosClient.get<GetActivitiesResponse>("/v1/activities", { params })
}
